import { faPhoneAlt } from "@fortawesome/pro-solid-svg-icons/faPhoneAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useMatch } from 'react-router-dom';
import CodeForm from "./CodeForm";
import { useCountryValue } from "./Contexts/CountryContext";
import PhoneNumber from "./Host/PhoneNumber";
import CountrySelector from "./Header/CountrySelector";
import DeviceSelector from "./Selectors/DeviceSelector";
var useState = React.useState,
  useEffect = React.useEffect;
function StickyHeader() {
  var _a = useState(window.scrollY || window.pageYOffset),
    top = _a[0],
    setTop = _a[1];
  var state = useCountryValue()[0];
  useEffect(function () {
    function handleScroll() {
      setTop(window.scrollY || window.pageYOffset);
    }
    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // Only appear on frontpage
  var routeMatch = useMatch('/');
  if (top < 250 || routeMatch && location.pathname !== '/') {
    return null;
  }
  var thePhoneNumber = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPhoneAlt
  }), "\u202F", /*#__PURE__*/React.createElement(PhoneNumber, null), " *");
  if (state.country === "de") {
    thePhoneNumber = /*#__PURE__*/React.createElement("span", {
      className: "hide-on-tablet hide-on-mobile"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faPhoneAlt
    }), /*#__PURE__*/React.createElement(PhoneNumber, null), " *");
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "sticky",
    className: "logoline fixed c-sticky-header",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "prodwidth center l-container h-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-30 tablet-grid-20 hide-on-mobile greyarrow c-sticky-header__section c-sticky-header__section--country"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement(CountrySelector, {
    hideText: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "grid-35 tablet-grid-40 hide-on-mobile whitearrow c-sticky-header__section c-sticky-header__section--number"
  }, /*#__PURE__*/React.createElement("div", {
    id: "numberSelection2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "numberline c-sticky-header__number"
  }, /*#__PURE__*/React.createElement(DeviceSelector, null), " \u00A0 ", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPhoneAlt
  })))), /*#__PURE__*/React.createElement("div", {
    className: "grid-35 tablet-grid-40 mobile-grid-100 greybox c-sticky-header__section c-sticky-header__section--code"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mobile-grid-55 hide-on-desktop hide-on-tablet grid-parent codeFormText c-sticky-header__text"
  }, "Anrufen\u00A0&\u00A0Code\u00A0eingeben:"), /*#__PURE__*/React.createElement("div", {
    className: "mobile-grid-45 grid-100 grid-parent"
  }, /*#__PURE__*/React.createElement("div", {
    id: "codeForm2 c-sticky-header__form"
  }, /*#__PURE__*/React.createElement(CodeForm, {
    position: 'sticky'
  }))))));
}
export default StickyHeader;